module.exports = __webpack_public_path__ + "img/INDUSTRIA_05_video_prew.ff438600.jpg";